import { useEffect, useMemo, useState } from "react";
import { subscribeStatements, createStatement, updateStatement, deleteStatement, writeStatementOrder } from "./statementService";

// One kind's statements (visions or fears), live, with the writes that change them. `goals` is the
// user's goal list, so links are only ever written to goals that exist.
export function useStatements(uid, kind, goals) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!uid) return undefined;
    setItems(null);
    setError(null);
    return subscribeStatements(uid, kind, setItems, setError);
  }, [uid, kind]);

  const goalIds = useMemo(() => new Set(goals.map(g => g.id)), [goals]);

  return {
    items: items || [],
    loading: items === null && !error,
    error,
    create: (fields) => createStatement(uid, kind, fields, goalIds),
    update: (statement, fields) => updateStatement(uid, kind, statement, fields, goalIds),
    remove: (statement) => deleteStatement(uid, kind, statement, goalIds),
    reorder: (ordered) => writeStatementOrder(uid, kind, ordered),
  };
}
